export const ButtonPaginacion = ({
  paginaActual,
  setPaginaActual,
  icon,
  sign,
}) => {
  return (
    <li>
      <button
        className="text-white font-bold p-1 bg-blue-500  hover:bg-blue-600 border-1 border-red-700 rounded-md"
        onClick={() =>
          setPaginaActual(
            sign === "+"
              ? paginaActual + 1
              : sign === "-"
              ? paginaActual - 1
              : paginaActual
          )
        }
      >
        <span>{icon} </span>
      </button>
    </li>
  );
};
